__turbopack_context__.v({
  "accountLink": "api-platform-module__idwIDW__accountLink",
  "appear": "api-platform-module__idwIDW__appear",
  "cardHeader": "api-platform-module__idwIDW__cardHeader",
  "cardPrice": "api-platform-module__idwIDW__cardPrice",
  "catalogNote": "api-platform-module__idwIDW__catalogNote",
  "categories": "api-platform-module__idwIDW__categories",
  "categoryBadge": "api-platform-module__idwIDW__categoryBadge",
  "complexPrice": "api-platform-module__idwIDW__complexPrice",
  "container": "api-platform-module__idwIDW__container",
  "detailButton": "api-platform-module__idwIDW__detailButton",
  "detailDescription": "api-platform-module__idwIDW__detailDescription",
  "detailGroup": "api-platform-module__idwIDW__detailGroup",
  "detailGroups": "api-platform-module__idwIDW__detailGroups",
  "detailModelId": "api-platform-module__idwIDW__detailModelId",
  "detailNote": "api-platform-module__idwIDW__detailNote",
  "detailTabs": "api-platform-module__idwIDW__detailTabs",
  "detailTags": "api-platform-module__idwIDW__detailTags",
  "dialog": "api-platform-module__idwIDW__dialog",
  "dialogBody": "api-platform-module__idwIDW__dialogBody",
  "dialogFeedback": "api-platform-module__idwIDW__dialogFeedback",
  "dialogHeader": "api-platform-module__idwIDW__dialogHeader",
  "docsCard": "api-platform-module__idwIDW__docsCard",
  "docsGrid": "api-platform-module__idwIDW__docsGrid",
  "docsHeading": "api-platform-module__idwIDW__docsHeading",
  "docsNote": "api-platform-module__idwIDW__docsNote",
  "empty": "api-platform-module__idwIDW__empty",
  "endpoints": "api-platform-module__idwIDW__endpoints",
  "eyebrow": "api-platform-module__idwIDW__eyebrow",
  "filterFooter": "api-platform-module__idwIDW__filterFooter",
  "filterRow": "api-platform-module__idwIDW__filterRow",
  "filters": "api-platform-module__idwIDW__filters",
  "guide": "api-platform-module__idwIDW__guide",
  "hero": "api-platform-module__idwIDW__hero",
  "manualCopy": "api-platform-module__idwIDW__manualCopy",
  "metadata": "api-platform-module__idwIDW__metadata",
  "modelCard": "api-platform-module__idwIDW__modelCard",
  "modelDescription": "api-platform-module__idwIDW__modelDescription",
  "modelGrid": "api-platform-module__idwIDW__modelGrid",
  "modelId": "api-platform-module__idwIDW__modelId",
  "navigationRow": "api-platform-module__idwIDW__navigationRow",
  "page": "api-platform-module__idwIDW__page",
  "pagination": "api-platform-module__idwIDW__pagination",
  "panel": "api-platform-module__idwIDW__panel",
  "priceGroup": "api-platform-module__idwIDW__priceGroup",
  "priceLines": "api-platform-module__idwIDW__priceLines",
  "pricePlan": "api-platform-module__idwIDW__pricePlan",
  "pricePlans": "api-platform-module__idwIDW__pricePlans",
  "priceSummary": "api-platform-module__idwIDW__priceSummary",
  "priceTier": "api-platform-module__idwIDW__priceTier",
  "readError": "api-platform-module__idwIDW__readError",
  "resultBody": "api-platform-module__idwIDW__resultBody",
  "results": "api-platform-module__idwIDW__results",
  "resultsActions": "api-platform-module__idwIDW__resultsActions",
  "resultsHeader": "api-platform-module__idwIDW__resultsHeader",
  "searchField": "api-platform-module__idwIDW__searchField",
  "searchInput": "api-platform-module__idwIDW__searchInput",
  "selectField": "api-platform-module__idwIDW__selectField",
  "skeletonCard": "api-platform-module__idwIDW__skeletonCard",
  "summaryLine": "api-platform-module__idwIDW__summaryLine",
  "tabs": "api-platform-module__idwIDW__tabs",
  "tags": "api-platform-module__idwIDW__tags",
  "toast": "api-platform-module__idwIDW__toast",
});
